/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FormControl, InputLabel, Input, InputAdornment, IconButton,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { withStyles } from '@material-ui/core/styles';


class PasswordField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  render() {
    const { classes } = this.props;

    return (
      <FormControl className={classes.root}>
        <InputLabel shrink htmlFor="adornment-password">{this.props.label}</InputLabel>
        <Input
          id="adornment-password"
          type={this.state.showPassword ? 'text' : 'password'}
          value={this.props.value}
          onChange={this.props.onChange}
          className={classes.root}
          placeholder={this.props.placeholder}
          endAdornment={(
            <InputAdornment position="end">
              <IconButton
                aria-label="Toggle password visibility"
                onClick={() => this.setState({ showPassword: !this.state.showPassword })}
              >
                {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          )}
          autoComplete={this.props.autoComplete}
        />
      </FormControl>
    );
  }
}

PasswordField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  classes: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  autoComplete: PropTypes.string,
};

PasswordField.defaultProps = {
  value: '',
  label: '',
  placeholder: '',
  autoComplete: '',
  onChange: () => {},
};

const styles = () => ({
  root: {
    marginTop: 14,
    display: 'flex',
    'label[data-shrink=false] + & ::-webkit-input-placeholder': {
      opacity: '0.5 !important',
    },
  },
});

export default withStyles(styles)(PasswordField);
